export enum ActionsPlanTypes {
  Opex = 'Opex',
  MDF = 'MDF',
  DGF = 'DGF',
  MIF = 'MIF',
}

export type TInvestmentSourceValue =
  | ActionsPlanTypes.Opex
  | ActionsPlanTypes.DGF
  | ActionsPlanTypes.MDF
  | 'Alliance Funds'

export enum KeyInitiativeInitTypes {
  ImportedInitiative = 'jbp-capabilities-pillar',
}

export enum EDescriptionQualityReason {
  Empty = 'EMPTY',
  NoText = 'NO_TEXT',
  Placeholder = 'PLACEHOLDER',
  TooShortHard = 'TOO_SHORT_HARD',
  DuplicatesNameHard = 'DUPLICATES_NAME_HARD',
  TooShort = 'TOO_SHORT',
  NotSpecific = 'NOT_SPECIFIC',
  NoMeasurableTarget = 'NO_MEASURABLE_TARGET',
  NoAction = 'NO_ACTION',
  Repetitive = 'REPETITIVE',
  DuplicatesName = 'DUPLICATES_NAME',
  GenericTemplate = 'GENERIC_TEMPLATE',
  LowInformation = 'LOW_INFORMATION',
  PossibleGibberish = 'POSSIBLE_GIBBERISH',
}

export interface IDescriptionQuality {
  Score: number
  Reasons: EDescriptionQualityReason[]
}

export type TDescriptionQualityField = string | IDescriptionQuality

export type KeyInitiative = {
  EntryId: number
  PreviousEntryId?: number | null
  PartnerId: string
  FYear: number
  ProgramType: string | null

  Description: string | null
  Development: string | null
  Name: string | null
  NameExt: string | null
  Status: string | null
  Period: string | null
  Parent: number | null

  HPInvestmentSum: number | null
  HPInvestmentSumUSD?: number | null
  HPInvestmentSource: TInvestmentSourceValue | null

  IsFromGlobalPartner: number
  IsNotApplicable: number | null
  KeyObjectiveCategory: string | null
  Comment: string | null
  ActivityType: string
  BusinessPriorities?: string | null
  KeyObjectiveTags: string

  DescriptionQuality?: TDescriptionQualityField | null

  FocusArea: string | null
  FocusAreaTranslation: string | null
  Owner: string
  Products: string | null
  DataInsightRelated: number
  Category: string | null

  GoalDescription: string | null
  IsAchieved: 1 | 0 | null
  ProofOfExecution: string | null
  InitType: KeyInitiativeInitTypes | null

  /** Bridge participation only, not an Incremental indicator. Selecting Incremental enables it, not vice versa. */
  AddToBridges: 1 | 0
  BusinessUnit: string | null
  PracticeBuilder?: string | null

  CurrentProgress?: string | null
  FollowUp?: string | null

  Currency: string | null
  ValueType: string | null
  Outcome?: string | null
  OutcomeValueType?: string | null
  FunnelSize?: number | null
  Leads?: number | null
  ConversionRate?: number | null
  Attendance?: number | null
  EstimateSales?: number | null

  Justification?: string | null
  IsCountriesAffected?: number | null
  CountriesAffectedList?: string | null

  GoalNdp: number | null
  GoalNdpUSD?: number | null
  GoalNdpLocalCurrency?: number | null

  GoalNet: number | null
  GoalNetUSD?: number | null
  GoalNetLocalCurrency?: number | null

  GoalTNet?: number | null
  GoalTNetUSD?: number | null
  GoalTNetLocalCurrency?: number | null

  GoalUTNet: number | null
  GoalUTNetUSD?: number | null
  GoalUTNetLocalCurrency?: number | null

  IncrementalNdp: number | null
  IncrementalNdpUSD?: number | null
  IncrementalNdpLocalCurrency?: number | null

  IncrementalNet: number | null
  IncrementalNetUSD?: number | null
  IncrementalNetLocalCurrency?: number | null

  IncrementalTNet: number | null
  IncrementalTNetUSD?: number | null
  IncrementalTNetLocalCurrency?: number | null

  IncrementalUTNet: number | null
  IncrementalUTNetUSD?: number | null
  IncrementalUTNetLocalCurrency?: number | null

  Created?: string
}

type TGPRollupKeyInitiativeFields = {
  Country: string
  CountryCode: string
  MarketL2: string
  MarketL3: string
  MarketL4: string
  MarketL5: string
  PartnerName: string
}

export type GPRollupKeyInitiative = KeyInitiative & TGPRollupKeyInitiativeFields

export type TKeyInitiative = KeyInitiative | GPRollupKeyInitiative

type TKeyInitiativesRequestParams = {
  fYear: number
  programType?: string | null
}

export type GetKeyInitiativesParams = TKeyInitiativesRequestParams & {
  partnerId: string
}

export type GetGPKeyInitiativesRollupParams = TKeyInitiativesRequestParams & {
  globalPartnerId: string
}
